import { render, staticRenderFns } from "./SanitizedCell.vue?vue&type=template&id=6e47d5e2"
import script from "./SanitizedCell.vue?vue&type=script&lang=js"
export * from "./SanitizedCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports